import z from "zod";

export const SHIFT_OVERLAP_ERROR = "SHIFT_OVERLAP_ERROR";
const OTHER_ERROR = "OTHER_ERROR";

export const detectKnownShiftOverlapError = (error: unknown) => {
  try {
    z.object({
      response: z.object({
        data: z.object({
          // This is not a user-facing string
          // oxlint-disable-next-line lingui/no-unlocalized-strings
          message: z.literal("Shift overlaps 1 other shift(s)."),
        }),
      }),
    }).parse(error);
    return SHIFT_OVERLAP_ERROR;
  } catch (_internalError) {
    return OTHER_ERROR;
  }
};
